import type { TransactionItemDetail } from 'models';
import { DonorsHorizontalCard } from '../donors-horizontal-card';

type P = {
  recentDonationsPayment: TransactionItemDetail[];
};

const RecentDonations = ({ recentDonationsPayment }: P) => (
  <DonorsHorizontalCard donorsPayment={recentDonationsPayment} title="Recent donations" />
);

export default RecentDonations;
